import { currentLocale } from '../../i18n'

/**
 * How an alert reads, in one place, so the banner on a project page and the
 * tooltip on the projects list can never word the same warning differently.
 *
 * The backend sends only a code, a severity and parameters -- deliberately, so
 * that adding a rule means adding two strings here and nothing else.
 */

/**
 * Thousands separators in the reader's locale, because these params are hours
 * and pesos and `2000000` is unreadable.
 *
 * `count` is left alone deliberately: i18next resolves the plural form from it,
 * and a formatted string would not resolve at all.
 */
function humanize(params) {
  const nf = new Intl.NumberFormat(currentLocale(), { maximumFractionDigits: 2 })
  const out = {}
  for (const [key, value] of Object.entries(params || {})) {
    out[key] = key !== 'count' && typeof value === 'number' ? nf.format(value) : value
  }
  return out
}

/** One alert as a sentence. Falls back to the bare code rather than vanishing. */
export function alertText(t, alert) {
  const key = `projectDetail.alerts.${alert.code}`
  // i18next returns the key itself when it has no string for it.
  const text = t(key, humanize(alert.params))
  return text === key ? alert.code : text
}

/** Which tab an alert is fixed in, so a banner can take you there. */
export const ALERT_TAB = {
  hours_over_budget: 'budget',
  money_over_budget: 'budget',
  orders_without_rate: 'budget',
  staffing_replacement: 'staffing',
  milestones_overdue: 'tasks',
}
